import React, { Component } from 'react';
import { compose, graphql } from 'react-apollo';
import Alert from 'react-bootstrap/Alert';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { SUBSCRIPTION_PREFERRED_LOCATION_CHANGED } from 'containers/DesktopNotificationTray';
import LoadingIndicator from 'components/LoadingIndicator';
import TextButton from 'components/TextButton';
import { augmentDrawing } from 'utils/drawings';
import { formatDate } from 'utils/formatting';
import DrawingLogo from '../DrawingLogo';
import { getDrawingsQuery } from '../utils/common';
import './PastWinners.css';

const PAGE_SIZE = 20;

class PastWinners extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataRequested: false,
      moreAllowed: true
    };
  }

  //  ---------------------------------
  onLoadMore() {
    this.setState({ dataRequested: true });
    this.props
      .loadMore()
      .then(resp => {
        if (
          resp.data.drawings &&
          resp.data.drawings.drawings &&
          resp.data.drawings.drawings.length < PAGE_SIZE
        ) {
          this.setState({ moreAllowed: false });
        }
      })
      .catch(error => {
        console.error('onLoadMore exception', error.toString());
      })
      .finally(() => {
        this.setState({ dataRequested: false });
      });
  }

  componentDidMount() {
    this.unsubscribeFromLocationData = this.props.subscribeToLocationData();
  }

  componentWillUnmount() {
    this.unsubscribeFromLocationData = () => {};
  }

  componentDidUpdate() {
    if (
      this.state.moreAllowed &&
      this.props.data.drawings &&
      this.props.data.drawings.drawings &&
      this.props.data.drawings.drawings.length < PAGE_SIZE
    ) {
      this.setState({ moreAllowed: false });
    }
  }

  checkErrors() {
    return this.props.data && this.props.data.error;
  }

  checkLoading() {
    return (
      !this.state.dataRequested && (!this.props.data || this.props.data.loading)
    );
  }

  //  ---------------------------------
  renderWinners(drawing) {
    const winners = drawing.claimedWinners();
    //  debug
    // const winners = [
    //   { user: { id: 666, displayName: 'John Kennedy' } },
    //   { user: { id: 667, displayName: 'Nathan' } },
    //   { user: { id: 668, displayName: 'Dave' } },
    //   { user: { id: 669, displayName: 'periscopehorse' } },
    //   { user: { id: 670, displayName: 'AverageJoeIII' } }
    // ];

    let winner1 = <div className="winner">No Winner</div>;
    let winner2 = null;
    let winner3 = null;
    let showMore = null;
    if (winners.length) {
      winner1 = (
        <div className="winner notranslate">
          {winners[0].user.displayName + (winners[1] ? ',' : '')}
        </div>
      );
      winner2 = winners[1] ? (
        <div className="winner notranslate">
          {winners[1].user.displayName + (winners[2] ? ',' : '')}
        </div>
      ) : null;
      winner3 = winners[2] ? (
        <div className="winner notranslate">{winners[2].user.displayName}</div>
      ) : null;

      if (winners.length > 3) {
        const tt = (
          <Tooltip className="drawings-tooltip past-winners" id="tooltip-0">
            {winners.map(w => (
              <p key={w.user.userId} className="notranslate">
                {w.user.displayName}
              </p>
            ))}
          </Tooltip>
        );
        // TODO ADA Keyboard Navigation
        showMore = (
          <OverlayTrigger
            overlay={tt}
            placement="bottom"
            delayShow={100}
            delayHide={200}
            trigger="click"
            rootClose
          >
            <p>(See All Winners)</p>
          </OverlayTrigger>
        );
      }
    }
    return (
      <div className="winners">
        <h5>Winners:</h5>
        {winner1}
        {winner2}
        {winner3}
        {showMore}
      </div>
    );
  }

  renderDrawing(drawing) {
    const prizes =
      drawing.winningPlaces &&
      drawing.winningPlaces.winningPlaces.map(place => place.prize);

    return (
      <div className="completed-drawing" key={'drawing' + drawing.id}>
        <DrawingLogo className="bigger-a-bit" prizes={prizes} />
        <div className="drawing-info">
          <div className="name">{drawing.name}</div>
          <div className="description">{drawing.description}</div>
          <div className="complete-date">
            <span>Ended: </span>
            <span className="highlight">
              {formatDate(drawing.drawTime, 'fullCompact')}
            </span>
          </div>
          {this.renderWinners(drawing)}
        </div>
      </div>
    );
  }

  render() {
    if (this.checkLoading()) {
      return <LoadingIndicator expand />;
    }

    if (this.checkErrors()) {
      return (
        <div className="Drawings-alert">
          <Alert variant="danger">
            <p>
              There was a problem retrieving the list of Drawings. Please try
              again later.
            </p>
          </Alert>
        </div>
      );
    }

    const { data } = this.props;
    const drawings = (data.drawings && data.drawings.drawings) || [];

    //  debug
    // drawings[1].drawingWinners = {
    //   drawingWinners: [
    //     { user: { id: 666, displayName: 'John Kennedy' } },
    //     { user: { id: 667, displayName: 'Nathan' } },
    //     { user: { id: 671, displayName: '++WhoTheHellIAm++' } },
    //     { user: { id: 668, displayName: 'Dave' } },
    //     { user: { id: 669, displayName: 'periscopehorse' } },
    //     { user: { id: 670, displayName: 'Average Joe III' } }
    //   ]
    // };
    //  debug

    return (
      <div className="completed-drawings-list-container">
        <div className="completed-drawings-list-content">
          {drawings.map((drawing, idx) => {
            return this.renderDrawing(drawing);
          })}
          {this.state.moreAllowed && (
            <div className="completed-drawing load-more">
              <TextButton onClick={() => this.onLoadMore()}>
                Load more ...
              </TextButton>
            </div>
          )}
          {!drawings.length && (
            <div className="drawings-list-content no-drawings">
              <div className="title">No Past Drawings</div>
            </div>
          )}
        </div>
        {this.state.dataRequested && <LoadingIndicator overlay />}
      </div>
    );
  }
}

//  ---------------------------------
export default compose(
  graphql(getDrawingsQuery(true /*winners*/), {
    options: props => ({
      fetchPolicy: 'cache-and-network',
      variables: {
        input: {
          states: ['Completed'],
          onlyMy: false,
          offset: 0,
          limit: PAGE_SIZE,
          sort: 'DESC'
        }
      }
    }),
    props: ({ data }) => {
      let drawings = [...((data.drawings && data.drawings.drawings) || [])];
      drawings.forEach(augmentDrawing);

      return {
        data,
        subscribeToLocationData: () => {
          return data.subscribeToMore({
            document: SUBSCRIPTION_PREFERRED_LOCATION_CHANGED,
            updateQuery: () => data.refetch()
          });
        },
        loadMore: () => {
          return data.fetchMore({
            variables: {
              input: {
                states: ['Completed'],
                onlyMy: false,
                limit: PAGE_SIZE,
                sort: 'DESC',
                offset: drawings.length
              }
            },
            updateQuery: (prev, { fetchMoreResult }) => {
              // console.log( 'updateQuery', prev, fetchMoreResult );
              if (!fetchMoreResult) {
                return prev;
              }
              prev = { ...prev };
              prev.drawings = { ...prev.drawings };
              prev.drawings.drawings = [...prev.drawings.drawings].concat(
                fetchMoreResult.drawings.drawings
              );

              // console.log( 'updateQuery, new data', prev );
              return prev;
            }
          });
        }
      };
    }
  })
)(PastWinners);
